<template>
  <header class="page-header flex-align-center">
    <div class="header-content flex-1 flex-center-between">
      <a href="/" class="header-logo">
        <img src="../assets/logo.png" />
      </a>
      <div class="header-nav flex-align-center">
        <div class="header-nav-menu" :class="[showMenu? 'active' : '', menuHide? 'menu-hidden' : '']">
          <h1 class="header-nav-title">MENU</h1>
          <nav class="nav-view flex">
            <a href="/brand.html" class="nav-item" :class="tab == 'brand'? 'active' : ''">
              <div class="nav-title">关于我们</div>
            </a>
            <a href="/join.html" class="nav-item" :class="tab == 'join'? 'active' : ''">
              <div class="nav-title">加盟合作</div>
            </a>
            <a href="/product.html" class="nav-item" :class="tab == 'product'? 'active' : ''">
              <div class="nav-title">产品介绍</div>
            </a>
            <a href="/news.html" class="nav-item" :class="tab == 'news'? 'active' : ''">
              <div class="nav-title">品牌营销</div>
            </a>
            <!--          <a class="nav-item">-->
            <!--            <div class="nav-title">品牌动态</div>-->
            <!--          </a>-->
            <a class="nav-item" @click="goFooter">
              <div class="nav-title">联系我们</div>
            </a>
            <a href="/brandEn.html" class="nav-item">
              <div class="nav-title">English</div>
            </a>
          </nav>
          <i class="el-icon-close menu-close" @click="mCloseMenu"></i>
        </div>
        <a href="tel:4006600326" class="tel-view">
          <img src="../assets/header-tel.png" />
        </a>
      </div>
    </div>
    <span class="m-menu-icon flex-center">
      <img class="klfs-icon" src="../assets/m-menus.png" alt="" @click="mShowMenu">
    </span>
  </header>
</template>
<script>
	export default {
    name: 'KlfsHeader',
    props: {
      tab: {
        type: String,
        value: ''
      }
    },
		data() {
			return {
        showMenu: false,
        menuHide: true,
			}
		},
		created() {

		},
    mounted() {

    },

		methods: {
      mShowMenu() {
        this.menuHide = false
        setTimeout(() => {
          this.showMenu = true
        }, 0)
      },
      mCloseMenu() {
        this.showMenu = false
        setTimeout(() => {
          this.menuHide = true
        }, 300)
      },
      goFooter() {
        document.querySelector('#pageFooter').scrollIntoView({
          behavior: 'smooth'
        });
        this.mCloseMenu()
      }
		}
	}
</script>
<style scoped>
.page-header {
  padding: 0 20px;
  height: 80px;
  background-color: #fff;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
}
.header-content {
  max-width: 1400px;
  margin: 0 auto;
}
.nav-view {
  font-size: 15px;
  font-weight: bold;
  color: #FF681E;
}
.nav-item {
  margin: 0 10px;
  padding: 4px 15px;
  cursor: pointer;
  user-select: none;
  transition: all .2s linear;
  border-radius: 40px;
}
.nav-item:hover {
  color: #fff;
  background-color: var(--p);
}
.nav-item.active {
  color: #fff;
  background-color: var(--p);
}
.tel-view {
  margin-left: 85px;
}
.m-menu-icon {
  display: none;
  width: 34px;
  height: 34px;
}
.header-nav-title {
  display: none;
}
.menu-close {
  display: none;
}
@media screen and (max-width: 1200px) {
  .nav-item {
    font-size: 14px;
    margin: 0 6px;
    padding: 4px 8px;
  }
  .tel-view {
    margin-left: 30px;
  }
}
@media screen and (max-width: 1000px) {
  .nav-item {
    font-size: 13px;
    margin: 0 5px;
    padding: 4px 6px;
  }
  .tel-view {
    margin-left: 20px;
  }
}
@media screen and (max-width: 900px) {
  .nav-item {
    font-size: 12px;
    margin: 0 4px;
    padding: 4px 4px;
  }
}
@media screen and (max-width: 768px) {
  .page-header {
    height: 68px;
  }
  .header-content {
    justify-content: left;
  }
  .header-logo {
    width: 85px;
    padding-right: 20px;
    margin-right: 20px;
    border-right: 2px solid var(--p);
  }
  .header-logo img,
  .tel-view img {
    display: block;
    width: 100%;
  }
  .tel-view {
    width: 128px;
    margin-left: 0;
  }
  .m-menu-icon {
    display: flex;
  }
  .header-nav-menu {
    //display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--o);
    padding: 28px 17px;
    transition: opacity .3s;
    opacity: 0;
    z-index: -1;
  }
  .header-nav-menu.active {
    //display: block;
    opacity: 1;
    z-index: 99;
  }
  .menu-hidden {
    display: none;
  }
  .header-nav-title {
    display: block;
    text-align: right;
    font-weight: bold;
    padding-right: 25px;
    margin-bottom: 32px;
    color: #fff;
  }
  .nav-view {
    color: #fff;
    flex-direction: column;
    font-size: 16px;
  }
  .nav-item {
    height: 48px;
    line-height: 48px;
    font-size: 15px;
    border-bottom: 1px solid #fff;
    border-radius: 0;
  }
  .menu-close {
    display: block;
    position: absolute;
    bottom: 40px;
    left: 50%;
    z-index: 2;
    font-size: 32px;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 50%;
    padding: 10px;
    margin-left: -27px;
  }
}
</style>